import React, { Component } from 'react'
import { Icon, Input, Spin, Modal, Button, notification } from "antd"
import PopupConfirm from "./PopupConfirm"
import PopupReceivedSewing from "./PopupReceivedSewing"
import { getInformationBatchByName, updateStatusBatch, updateBatchReceiveSewName, markBatchSewed } from "../../../services/api/3dApi"

class UpdateBatchesPage extends Component {
    state = {
        getLoading: false,
        updateLoading: false,
        message: '',
        showModal: '',
        visible: false,
        disable: true,
        batch: {},
        nextStatus: '',
        scanValue: '',
        cacheValue: '',
        valueInput: '',
        errorInput: '',
        partnerSewingId: '',
        giveSewName: '',
        receiveSewName: '',
        material_weight: '',
    }

    _input = React.createRef()

    _resetScanInput = () => {
        this.setState({
            message: '',
            disable: true,
            batch: {},
            scanValue: '',
            valueInput: '',
            partnerSewingId: '',
            giveSewName: '',
            receiveSewName: '',
            material_weight: '',
        }, () => {
            this._input.current.focus()
        })
    }

    _handleChangeSelect = (value) => {
        this.setState({
            partnerSewingId: value
        })
    }

    _handleChangeInput = (name, value) => {
        this.setState({
            [name]: value
        })
    }

    _handleChangeScan = (e) => {
        let { value } = e.target

        this.setState({
            message: '',
            errorInput: '',
            valueInput: value
        })
    }

    _onSubmit = (e) => {
        e.preventDefault()

        const { valueInput } = this.state
        const check = /^\w+-\d/.test(valueInput)

        this.setState({
            message: '',
            disable: true,
            batch: {},
            errorInput: !check ? 'Mã lô sai định dạng.' : ''
        }, () => {
            const valueFormatted = valueInput.trim()

            if (!valueFormatted) {
                return this.setState({
                    errorInput: 'Mã lô sai định dạng.'
                })
            }

            check && this._getBatchDetailByName(valueFormatted.toUpperCase())
        })
    }

    _getBatchDetailByName = async (value) => {
        this.setState({
            getLoading: true,
            message: '',
            scanValue: ''
        })

        try {
            const { data: response } = await getInformationBatchByName({ name: value })
            const { success, data, error } = response
            if (!success) {
                return this.setState({
                    getLoading: false,
                    message: error,
                    scanValue: ''
                }, () => {
                    Modal.error({
                        title: 'Lỗi',
                        content: error,
                        okText: 'Đóng'
                    })
                })
            }

            const { disable, message, batch, nextStatus } = data

            if (message !== '' && disable) {
                Modal.error({
                    title: 'Lỗi',
                    content: data.message,
                    onOk: this._resetScanInput(),
                    okText: 'Đóng'
                })
            }

            this.setState({
                getLoading: false,
                message: message,
                disable: disable,
                batch: batch,
                nextStatus: nextStatus,
                scanValue: ''
            }, () => {
                const { status } = batch
                const haveReceiveSewName = batch.hasOwnProperty('receive_sew_name')

                if (nextStatus === '' && status === 'sewing' && (!haveReceiveSewName || batch.receive_sew_name === '')) {
                    this._showModal('receiveSewName')
                } else if (nextStatus === '' && status === 'sewing' && haveReceiveSewName && batch.receive_sew_name !== '') {
                    Modal.error({
                        title: 'Lỗi',
                        content: 'Lô đã nhận may. Không được phép cập nhật trạng thái lô!',
                        onOk: this._resetScanInput(),
                        okText: 'Đóng'
                    })
                }
            })
        } catch (e) {
            this.setState({
                getLoading: false
            }, () => {
                Modal.error({
                    title: 'Lỗi',
                    content: e.message,
                    onOk: this._resetScanInput(),
                    okText: 'Đóng'
                })
            })
        } finally {
            this._input.current.focus()
        }
    }

    _updateStatus = async () => {
        this.setState({
            updateLoading: true
        })

        try {
            const { _id } = this.state.batch
            const { nextStatus, partnerSewingId, giveSewName, material_weight } = this.state
            const payload = {
                partner: partnerSewingId,
                batchId: _id,
                status: nextStatus,
                give_sew_name: giveSewName.trim()
            }
            if (material_weight !== '') payload.material_weight = parseFloat(material_weight)

            const { data: response } = await updateStatusBatch(_id, payload)
            const { data, success, error } = response

            if (!success) {
                return this.setState({
                    updateLoading: false,
                    scanValue: ''
                }, () => {
                    Modal.error({
                        title: 'Lỗi',
                        content: error,
                        okText: 'Đóng'
                    })
                })
            }

            const { message, batchUpdate } = data

            this.setState({
                updateLoading: false,
            }, () => {
                this._hiddenModal()
                this._resetScanInput()

                notification.success({
                    message: `Lô ${batchUpdate.name} đã được cập nhật trạng thái ${batchUpdate.status}.`,
                    description: message,
                })
            })
        } catch (e) {
            this.setState({
                updateLoading: false,
            }, () => {
                this._hiddenModal()
                Modal.error({
                    title: 'Lỗi',
                    content: e.message,
                    okText: 'Đóng'
                })
            })
        } finally {
            this._input.current.focus()
        }
    }

    _updateReceiveSewName = async () => {
        this.setState({
            updateLoading: true
        })

        try {
            const { _id } = this.state.batch
            const { receiveSewName } = this.state
            const payload = {
                receive_sew_name: receiveSewName.trim()
            }

            const { data: response } = await updateBatchReceiveSewName(_id, payload)
            const { data, success, error } = response

            if (!success) {
                return this.setState({
                    updateLoading: false,
                    scanValue: ''
                }, () => {
                    this._hiddenModal()
                    Modal.error({
                        title: 'Lỗi',
                        content: error,
                        okText: 'Đóng'
                    })
                })
            }

            const { receive_sew_name, name } = data

            this.setState({
                updateLoading: false,
            }, () => {
                this._hiddenModal()
                this._resetScanInput()

                notification.success({
                    message: `Lô ${name} đã được cập nhật người nhận may là: ${receive_sew_name}.`,
                })
            })
        } catch (e) {
            this.setState({
                updateLoading: false,
            }, () => {
                this._hiddenModal()
                Modal.error({
                    title: 'Lỗi',
                    content: e.message,
                    okText: 'Đóng'
                })
            })
        } finally {
            this._input.current.focus()
        }
    }

    _showModal = (type) => {
        document.body.classList.add('CustomPopup')

        this.setState({
            showModal: type,
            visible: true
        })
    }

    _hiddenModal = () => {
        document.body.classList.remove('CustomPopup')

        this.setState({
            showModal: '',
            visible: false
        })
    }

    _markBatchSewed = async () => {
        this.setState({
            getLoading: true,
            message: '',
            scanValue: ''
        })

        try {
            const { _id } = this.state.batch
            const { data: response } = await markBatchSewed(_id)
            const { data, success, error } = response

            if (!success) {
                return this.setState({
                    getLoading: false,
                    scanValue: ''
                }, () => {
                    Modal.error({
                        title: 'Lỗi',
                        content: error,
                        okText: 'Đóng'
                    })
                })
            }
            const { name } = data
            this.setState({
                getLoading: false,
            }, () => {
                this._resetScanInput()
                notification.success({
                    message: `Lô ${name} đã được đánh dấu may xong thành công.`,
                })
            })

        } catch (e) {
            this.setState({
                getLoading: false,
            }, () => {
                Modal.error({
                    title: 'Lỗi',
                    content: e.message,
                    okText: 'Đóng'
                })
            })
        } finally {
            this._input.current.focus()
        }
    }

    render() {
        const {
            getLoading,
            updateLoading,
            message,
            showModal,
            visible,
            disable,
            batch,
            nextStatus,
            valueInput,
            errorInput,
            partnerSewingId,
            giveSewName,
            material_weight,
            receiveSewName
        } = this.state

        const { total_items, available_items_number, status, production_meta = {} } = batch

        return (
            <div className="UpdateBatchesPage">
                <div className="position-relative">
                    <Spin spinning={getLoading} tip='Đang kiểm tra...'>
                        <form onSubmit={this._onSubmit} className="formQC">
                            <Input
                                value={valueInput.toUpperCase()}
                                style={{ fontSize: 40, height: "auto" }}
                                ref={this._input}
                                autoFocus={true}
                                placeholder='Nhập vào tên lô'
                                onChange={this._handleChangeScan}
                            />

                            {
                                valueInput &&
                                <Icon
                                    type='close-circle'
                                    className="position-absolute cursor-pointer text-dark IconInput"
                                    onClick={this._resetScanInput}
                                />
                            }

                            {
                                getLoading &&
                                <Icon type="sync" spin className="position-absolute IconInput" />
                            }

                            {
                                (!getLoading && !disable && nextStatus !== '') &&
                                <Button
                                    type='primary'
                                    className='float-right mt-5'
                                    onClick={() => this._showModal('giveSewName')}
                                >
                                    {message}
                                </Button>
                            }

                            {
                                (!getLoading && status === "sewing" && !production_meta.sewed) &&
                                <Button
                                    type='primary'
                                    className='float-right mt-5'
                                    onClick={() => this._markBatchSewed()}
                                    style={{ fontSize: 20 }}
                                >
                                    Đánh dấu lô may xong
                                </Button>
                            }
                        </form>

                        {errorInput && <div className="text-danger mt-3">{errorInput}</div>}
                    </Spin>

                    {
                        showModal === 'giveSewName' && (<PopupConfirm
                            partner={partnerSewingId}
                            giveSewName={giveSewName}
                            visible={visible}
                            loading={updateLoading}
                            status={nextStatus}
                            message={message}
                            total={total_items}
                            item={available_items_number}
                            material_weight={material_weight}
                            batch={batch}
                            onUpdate={this._updateStatus}
                            onClose={this._hiddenModal}
                            onChangeSelect={this._handleChangeSelect}
                            onChangeInput={this._handleChangeInput}
                        />)
                    }

                    {
                        production_meta.sewed && showModal === 'receiveSewName' && (<PopupReceivedSewing
                            loading={updateLoading}
                            visible={visible}
                            receiveSewName={receiveSewName}
                            onUpdate={this._updateReceiveSewName}
                            onClose={this._hiddenModal}
                            onChangeInput={this._handleChangeInput}
                        />
                        )
                    }
                </div>
            </div>
        )
    }
}

export default UpdateBatchesPage
